import Time from "../helper/Time";

const Post = (record, isSnippet) => {

    if (!record.post) return "";

    const postDate = (isSnippet) ? Time.ageFormatter(record.post.record.createdAt) : "";

    return `
        <div style="display: flex; flex-direction: column;">
            <p>${record.post.uri}</p>
            <div>
                <div style="display: flex; gap: 1rem; justify-content: space-between;">
                    <div style="display: flex; gap: 1rem; align-items: center;">
                        ${(record.post.author.avatar != undefined) ? '<img src="' + record.post.author.avatar + '" width="40" height="40">' : ""}
                        <div style="display: flex; flex-direction: column;">
                            ${(record.post.author.displayName != undefined) ? '<strong>' + record.post.author.displayName + '</strong>' : ""}
                            <div>@${record.post.author.handle}</div>
                        </div>
                    </div>
                    <div>
                        ${(isSnippet) ? '<p title="' + new Date(record.post.record.createdAt) + '">' + postDate + ' ago</p>' : ""}
                    </div>
                </div>
            </div>
            ${(record.post.record.text != undefined) ? '<p>' + record.post.record.text + '</p>' : ""}
            ${(record.post.embed != undefined) ? `<strong>Embed in post.</strong>` : ""}
            <div style="display: flex; gap: 1rem">
                <p>Comments: <strong>${record.post.replyCount}</strong></p>
                <p>Reposts: <strong>${record.post.repostCount}</strong></p>
                <p>Quotes: <strong>${record.post.quoteCount}</strong></p>
                <p>Likes: <strong>${record.post.likeCount}</strong></p>
            </div>
        </div>
    `;
}

export default Post;